import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from "@angular/core";
import {
  ProductRestriction,
  ProductVariantShort,
  Seller
} from "src/app/common/common-product/models/product-short.model";
import {FormBuilder} from "@angular/forms";
import {EnvironmentService} from "../../../snatch/services";
import {Contract} from "src/app/snatch/models/contract.model";
import {Select, Store} from "@ngxs/store";
import {AuthTokenState} from "../../../auth/state/auth-token.state";
import {Observable} from "rxjs";
import {CheckDMConversation} from "../../../inbox/state/inbox.state";
import {BundleQueryModel} from "../../models/bundle.model";

@Component({
  selector: "leap-main-details",
  templateUrl: "./main-details.component.html",
  styleUrls: ["./main-details.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MainDetailsComponent implements OnInit, OnChanges {
  @Input() id: string;
  @Input() sku: string;
  @Input() name: string;
  @Input() type: string;
  @Input() suffix: string;
  @Input() price: number;
  @Input() currency: string;
  @Input() sellerName: string;
  @Input() shortDescription: string;
  @Input() variants: ProductVariantShort[];
  @Input() seller: Seller;
  @Input() selectedVariant: ProductVariantShort;
  @Input() languages: string[];
  @Input() deliveryFormats: string[];
  @Input() certificateTypes: string[];
  @Input() courseDeliveryFormats: Array<any>;
  @Input() restriction: ProductRestriction;
  @Input() restrictionMessage: string;
  @Input() expiringContract: Contract;
  @Input() isBundleType: boolean;
  @Input() bundle: BundleQueryModel;

  @Select(AuthTokenState.isLogged)
  isLogged$: Observable<boolean>;

  imageLoading: boolean;
  brokenImage: boolean;
  deliveryFormatLabel: string = 'Course';
  imageUrl: string;

  constructor(private fb: FormBuilder, private chgRef: ChangeDetectorRef, private envService: EnvironmentService, private store: Store) {
  }

  ngOnChanges(changes: SimpleChanges) {
    const { selectedVariant } = changes;
    if (selectedVariant) {
      const newImageUrl = (this.selectedVariant.renders.length && this.selectedVariant.renders[0].mediumImageUri ? this.selectedVariant.renders[0].mediumImageUri : null);
      if (newImageUrl && (this.imageUrl !== newImageUrl)) {
        this.imageUrl = newImageUrl;
        this.imageLoading = true;
      }
    }
  }

  ngOnInit() {
    if(this.deliveryFormats && this.deliveryFormats.length > 0){
      this.deliveryFormats.forEach((it:any)=>{
        if(it.configKey === "product-assessment") this.type = 'Assessment';
        if(this.envService.isQA || this.envService.isPreview || this.envService.isProdin ){
        this.setDeliveryFormatLabel(it.configKey)
        }
      })
    }
  }

  contactSeller() {
    this.store.dispatch(new CheckDMConversation(this.seller.name));
  }

  setDeliveryFormatLabel(type: any) {
    switch(type) {
        case 'diagnostics':
            this.deliveryFormatLabel = 'Diagnostic';
            this.type = 'Diagnostic'
            break;
        case 'product-assessment':
            this.deliveryFormatLabel = 'Assessment';
            break;
        case 'lab':
            this.deliveryFormatLabel = 'vLab';
            this.type= 'vLab'
            break;
        default:
            this.deliveryFormatLabel = 'Course';
    }
}
}
